






























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  expenseReimbursementMethodMap,
  expenseReimbursementStatusMap,
  HsabExpenseReimbursementResponse,
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";

@Component({})
export default class AccountHolderExpenseRepayments extends Vue {
  formatCurrency = formatCurrency;
  expenseReimbursementMethodMap = expenseReimbursementMethodMap;
  expenseReimbursementStatusMap = expenseReimbursementStatusMap;

  @Prop()
  reimbursement: HsabExpenseReimbursementResponse;

  get hasRepayments () {
    return this.reimbursement
        && this.repayments
        && this.repayments.length > 0;
  }

  get repayments () {
    return this.reimbursement.repayments;
  }
}
